import { EmptyView } from "@/components/view";
import { useTranslation } from "@/hooks";
import { useUIStore } from "@/stores/ui";

export function ProjectEmptyView({ projectId }: { projectId: string }) {
  const { t } = useTranslation();
  const openModal = useUIStore((state) => state.openModal);

  return (
    <EmptyView
      title={t("projects").noWorkspaces}
      description={t("projects").noWorkspacesDescription}
      height="60vh"
      button={{
        label: t("projects").createWorkspace,
        onClick: () =>
          openModal(undefined, "workspace", undefined, { defaultProjectId: projectId }),
      }}
    />
  );
}
